// Handed to window.open, a target with one of these does something other than open a document,
// so it is rejected here rather than passed on. Everything else is the browser's decision:
// data: and blob: image sources, file: links into a network share, and the custom protocols an
// enterprise knowledge base may deep-link with are all legitimate card content, and a guard
// that second-guesses which of them the engine will honour just breaks them silently instead.
const REJECTED_PROTOCOLS = [
  // eslint-disable-next-line no-script-url
  'javascript:', // Runs script rather than opening anything.
  'about:', // What the editor's sanitizeUrl yields for a scheme it does not support.
];

// Card content is authored by customers, and the editor's link dialog seeds a new link with a
// bare `https://` placeholder, so a target reaching a link handler is not necessarily openable.
// `window.open` throws a SyntaxError on those, which unhandled takes the whole card down.
// Returns the URL to open, or null when there is nothing sensible to open.
export default function resolveOpenableUrl(url: string): string | null {
  // Both of these are rejected before parsing, because resolved against the page they yield
  // the page itself rather than throwing, and reopening live in a second window is not what
  // the link meant: an empty target, and a scheme with nothing after it.
  const trimmed = url.trim();
  if (!trimmed || /^[a-z][a-z0-9+.-]*:\/*$/i.test(trimmed)) {
    return null;
  }

  try {
    // Resolved against the page so that a relative document or image path still opens.
    const target = new URL(url, window.location.href);
    return REJECTED_PROTOCOLS.includes(target.protocol) ? null : target.href;
  } catch {
    return null;
  }
}
